<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.complementaryExams', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mComplementary.reference }}
                        </h3>
                    </div>

                    <div class="list-group list-group-flush">
                        <div class="list-group-item">
                            {{ $tc('message.references', 1) }}:

                            <span class="font-weight-bold">
                                {{ mComplementary.reference }}
                            </span>
                        </div>

                        <div class="list-group-item">
                            {{ $t('message.description') }}:

                            <div class="font-weight-bold">
                                {{ mComplementary.description }}
                            </div>
                        </div>
                    </div>

                    <div class="card-footer text-right">
                        <b-button v-b-modal.delete-modal variant="danger">
                            {{ $t('message.delete') }}
                        </b-button>
                    </div>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.complementaryExams', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mComplementary.reference }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteComplementaryExam">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "ComplementaryExam",

        computed: {
            ...mapGetters(["complementaryExam"]),

            mComplementary: function() {
                return this.complementaryExam;
            }
        },

        data() {
            return {
                complementary_id: this.$route.params.complementary
            }
        },

        methods: {
            getComplementaryExam() {
                let args = {
                    complementary: this.complementary_id
                };

                this.$store.dispatch("getComplementaryExam", { args });
            },

            deleteComplementaryExam() {
                let self = this;
                let args = {
                    complementary: this.complementary_id
                };

                let successMessage = this.$i18n.t('message.complementaryExamDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteHospitalisationComplementaryExam', { args, index: self.complementary_id, successMessage, errorMessages });
            }
        },

        mounted() {
            this.getComplementaryExam();
        }
    }
</script>

<style scoped>

</style>